import React, {useState} from 'react';
import {Collapse} from 'reactstrap';

// Panel with an always-visible summary row and an optional collapsible body.
// Replaces the old details-card + edit-modal pattern: the body holds the form inline.
// Uncontrolled by default; pass open/onToggle to control it from the parent.
const SettingsPanel = ({ icon, title, summary, children, defaultOpen = false, toggleLabel = 'Edit', open: controlledOpen, onToggle }) => {
    const [localOpen, setLocalOpen] = useState(defaultOpen);
    const open = controlledOpen !== undefined ? controlledOpen : localOpen;
    const toggle = () => (onToggle ? onToggle(!open) : setLocalOpen(!open));

    return (
        <div className="settings-panel border-start border-primary bg-broken mb-3">
            <div
                className={`panel-header d-flex align-items-center justify-content-between p-3${children ? ' pointer' : ''}`}
                onClick={() => children && toggle()}
            >
                <div>
                    <p className="mb-0 text-uppercase text-primary">
                        <span className={`fas fa-fw ${icon} me-2`}/>
                        {title}
                    </p>
                    {summary && (
                        <div className="d-flex align-items-center flex-wrap gap-1 mt-1">
                            {summary}
                        </div>
                    )}
                </div>
                {children && (
                    <span className="text-primary text-uppercase small text-nowrap ms-3">
                        {!open && toggleLabel}
                        <span className={`fas fa-chevron-${open ? 'up' : 'down'} ms-2`}/>
                    </span>
                )}
            </div>
            {children && (
                <Collapse isOpen={open}>
                    <div className="panel-body px-3 pb-3">
                        {children}
                    </div>
                </Collapse>
            )}
        </div>
    );
};

export default SettingsPanel;
